import React from 'react';
import classNames from './Header.module.scss';

interface HeaderProps {
  items: {
    label: string;
    value?: string | string[];
  }[];
}

const Header = ({ items }: HeaderProps) => {
  return (
    <div className={classNames.header}>
      {items.map((item, index) => {
        const values = Array.isArray(item.value) ? item.value : item.value ? [item.value] : [];
        return (
          <div key={`headerItem--${index}`} className={classNames.headerItem}>
            <h3>
              <span className={classNames.text}>{item.label}</span>
            </h3>
            <h2>
              {values.map((value, valueIndex) => (
                <span key={`value--${valueIndex}`} className={classNames.text}>
                  {value}
                </span>
              ))}
            </h2>
          </div>
        );
      })}
    </div>
  );
};

export default Header;
